// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

export const isNode = !!(typeof process !== 'undefined' && process.versions && process.versions.node);
